import { OverallValidationResult, validator } from '../../../tradebuilder-v2/util'
import { BankUsersState } from '../bank-users-slice'
import { bankUserRules } from './bank-users'

const bankUsersValidator = validator(bankUserRules)

export function validate(usersState: BankUsersState): OverallValidationResult {
  return bankUsersValidator(usersState)
}
